














































































































































































import DatePicker from '@/components/ui/DatePicker.vue'
import { formatarMoeda } from '@/shareds/formatadores'
import { FormaDePagamento, PontoDeVendaComTurno, Titulo } from '@/models'
import { BaixaDePagamentoForm, TipoDeTransacaoDaBaixaDePagamento } from '@/models/financeiro/BaixaDePagamento'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { CreateBaixaDePagamentoUseCase, FindBaixaDePagamentoUseCase, FindTituloUseCase } from '@/usecases'
import { Vue, Component, Watch, Ref, Prop } from 'vue-property-decorator'
import moment from 'moment-timezone'
import { FindPdvUseCase } from '@/usecases/pdv/FindPdvUseCase'
import { obrigatorio } from '@/shareds/regras-de-form'
import { dateTimeToPtBrFormat } from '@/shareds/date/date-utils'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import Decimal from 'decimal.js'

@Component({
	components: {
		DatePicker,
	},
})
export default class DialogoDeEdicaoDeEstornoDePagamentosDosTitulos extends Vue {
	@Ref() form!: HTMLFormElement
	@Prop({ type: Boolean, default: false }) retornoCrediario!: boolean
	@Prop({ type: Boolean, default: false }) contasAPagar!: boolean
	@Ref() menu!: {
		save: (value?: any) => void
	}

	obrigatorio = obrigatorio
	formatarMoeda = formatarMoeda
	dateTimeToPtBrFormat = dateTimeToPtBrFormat

	data = ''
	horas = ''
	buscando = false
	salvando = false
	mostra = false
	menu2 = false
	time = null
	titulo: Titulo | null = null
	valorFaltante: number | null = null
	valorFaltanteAtualizado: number | null = null
	formaDePagamento = ''
	turnoDeVendaId: string | null = null

	dataPagamento: string | null = null
	valorMaximoParaEstorno: number | null = null
	totalValorBaixa: number | null = null
	totalValorDesconto: number | null = null
	totalValorTaxa: number | null = null
	valorJurosSobreBaixa: number | null = null
	valorDaMultaSobreBaixa: number | null = null
	valorFaltanteDoTitulo: number | null = null

	createBaixaDePagamentoUseCase = new CreateBaixaDePagamentoUseCase()
	findTituloUseCase = new FindTituloUseCase()
	findBaixaDePagamentoUseCase = new FindBaixaDePagamentoUseCase()
	findPdvUseCase = new FindPdvUseCase()

	pdvOptions: PontoDeVendaComTurno[] = []
	tipoDeTransacaoDaBaixaDePagamento = TipoDeTransacaoDaBaixaDePagamento

	baixaDePagamento: BaixaDePagamentoForm = {
		titulo: null,
		transactionId: '',
		valorPagamento: 0,
		valorTaxa: 0,
		dataHoraPagamento: '',
		isTaxa: false,
		isIntegracao: false,
		formaDePagamento: null,
		valorDesconto: 0,
		turnoDeVendaId: null,
		tipoDeTransacao: null,
		estornado: null,
		valorJurosSobreBaixa: 0,
		valorDaMultaSobreBaixa: 0,
		valorTotalTitulo: 0,
	}

	opcoesDeFormaDePagamento: FormaDePagamento[] = [
		'Dinheiro',
		'Cartão',
		'Pix',
	]

	opcoesDeFormaDePagamentoCaixa: FormaDePagamento[] = [
		'Dinheiro',
		'Cartão',
		'Pix',
	]

	get permitirAlterarDataBaixa() {
		return UserLoginStore.permiteRegraDeNegocio('permitir-alteracao-data-pagamento')
	}

	@Watch('mostra', { immediate: true })
	changeDate() {
		if(!this.mostra) return

		this.data = moment().format('YYYY-MM-DD')
		this.horas = new Date().toLocaleTimeString('pt-BR')
	}

	@Watch('data', { deep: true, immediate: true })
	@Watch('baixaDePagamento', { deep: true, immediate: true })
	calcularValorFaltante() {
		if(this.valorFaltanteAtualizado === null || !this.titulo) return

		if (
			this.titulo.formaDePagamento === "CREDIARIO" &&
			this.titulo.fluxo === 'Entrada'
		) {
			const valorLiquidoAtualizado = (this.titulo.valorAtualizado || 0) - (this.titulo.juros || 0)
			const data = new Date(`${this.data}T${this.horas}`)
			const dataAposCarencia = this.calcularDataAposCarencia(this.titulo, new Date(this.titulo.dataDeVencimento))
			const capital = new Decimal(valorLiquidoAtualizado)
			const taxa = new Decimal(this.titulo.porcentagemDeJuros || 0).div(100)
			const diferencaMs = data.getTime() - dataAposCarencia.getTime()
			const dias =  Math.ceil(diferencaMs / (1000 * 60 * 60 * 24))
			const expoente = new Decimal(dias)
			const montante = capital.mul(Decimal.pow(1 + taxa.toNumber(), expoente.toNumber()))
			const montanteArrendondado = Number(montante.toFixed(2)) + Number(this.titulo.multa)
			
			this.valorFaltante = (montanteArrendondado - Number(this.titulo.multa) <= this.titulo.valor ? this.titulo.valor : montanteArrendondado)
			this.valorFaltanteAtualizado = (montanteArrendondado - Number(this.titulo.multa) <= this.titulo.valor ? this.titulo.valor : montanteArrendondado) - this.baixaDePagamento.valorPagamento
		}
		
	}

	calcularDataAposCarencia(titulo: Titulo, dataAposCarencia: Date): Date {
		dataAposCarencia.setDate(dataAposCarencia.getDate() + (titulo.diasDeCarencia || 0))

		const diaDaSemana = dataAposCarencia.getDay();
		if (diaDaSemana === 6) { // Sábado
			dataAposCarencia.setDate(dataAposCarencia.getDate() + 2)
		} else if (diaDaSemana === 0) { // Domingo
			dataAposCarencia.setDate(dataAposCarencia.getDate() + 1)
		}

		const hojeBrasil = new Date()
		hojeBrasil.setHours(0, 0, 0, 0)
		if (dataAposCarencia.getTime() === hojeBrasil.getTime()) {
			dataAposCarencia.setDate(dataAposCarencia.getDate() + 1)
		}

		return dataAposCarencia
	}

	async mostrarDialogo(valorValidoParaEstornos: number, titulo: Titulo, totalValorBaixa: number, totalValorDesconto: number, totalValorTaxa: number, valorJurosSobreBaixa: number, valorDaMultaSobreBaixa: number) {
		this.pdvOptions = []
		this.valorMaximoParaEstorno = valorValidoParaEstornos

		const tituloCompleto = await this.findTituloUseCase.findById(titulo.id)

		this.titulo = tituloCompleto
		this.totalValorBaixa = totalValorBaixa
		this.totalValorDesconto = totalValorDesconto
		this.totalValorTaxa = totalValorTaxa
		this.valorJurosSobreBaixa = valorJurosSobreBaixa
		this.valorDaMultaSobreBaixa = valorDaMultaSobreBaixa
			
		this.calcularValorFaltante()
		this.preencherPdvAutomatico()
		this.buscarPdvAberto()
		this.mostra = true
	}

	preencherPdvAutomatico() {
		if (this.contasAPagar) return;
		const turnoDeVenda = JSON.parse(localStorage.getItem('TURNO_DE_VENDA_STORAGE') || 'null')

		if (turnoDeVenda && turnoDeVenda.pontoDeVenda && this.titulo && this.titulo.loja) {

			if (turnoDeVenda.pontoDeVenda.loja.id === this.titulo.loja.id) {
				const pdv = {
					turnoDeVendaId: turnoDeVenda.id,
					nomePontoDeVenda: turnoDeVenda.pontoDeVenda.nome,
				};

				if (!this.pdvOptions.some(p => p.turnoDeVendaId === pdv.turnoDeVendaId)) {
					this.pdvOptions = [pdv, ...this.pdvOptions];
				}

				if (!this.baixaDePagamento.turnoDeVendaId) {
					this.baixaDePagamento.turnoDeVendaId = pdv.turnoDeVendaId;
				}
			}
		}
	}

	async buscarPdvAberto() {
		if (!this.titulo || !this.titulo.loja) return

		const pdvs = await this.findPdvUseCase.buscarPdvSemTurno(this.titulo.loja.id)
		this.pdvOptions = [...this.pdvOptions, ...pdvs]
	}

	async salvarBaixa() {
		if (!this.baixaDePagamento) return
		if(this.totalValorBaixa  == null || this.totalValorDesconto == null || this.totalValorTaxa == null) return

		const baixaDisponivelParaEstorno = -Math.abs(this.totalValorBaixa)
		const descontoDisponivelParaEstorno = -Math.abs(this.totalValorDesconto)
		const taxaDisponivelParaEstorno = -Math.abs(this.totalValorTaxa)
		const valorDaMultaDisponivelParaExtorno = -Math.abs(Number(this.valorDaMultaSobreBaixa))
		const valorDeJurosDisponivelParaExtorno = -Math.abs(Number(this.valorJurosSobreBaixa))

		if(!this.baixaDePagamento.valorPagamento && this.baixaDePagamento.valorPagamento !== 0){
			AlertModule.setError('Valor de Pagamento não pode estar vazio');
			return
		}

		if(!this.baixaDePagamento.valorDaMultaSobreBaixa && this.baixaDePagamento.valorDaMultaSobreBaixa !== 0){
			AlertModule.setError('Valor da Multa não pode estar vazio');
			return
		}

		if(!this.baixaDePagamento.valorJurosSobreBaixa && this.baixaDePagamento.valorJurosSobreBaixa !== 0){
			AlertModule.setError('Valor de Juros não pode estar vazio');
			return
		}

		if(Math.abs(this.baixaDePagamento.valorPagamento) > Math.abs(baixaDisponivelParaEstorno)){
			AlertModule.setError('Valor da Baixa Excede o Total Dispoivel para Estorno')
			return
		}

		if(Math.abs(this.baixaDePagamento.valorDesconto) > Math.abs(descontoDisponivelParaEstorno)){
			AlertModule.setError('Valor do Desconto Excede o Total Dispoivel para Estorno')
			return
		}

		if(Math.abs(this.baixaDePagamento.valorTaxa) > Math.abs(taxaDisponivelParaEstorno)){
			AlertModule.setError('Valor da Taxa Excede o Total Dispoivel para Estorno')
			return
		}

		if(Math.abs(this.baixaDePagamento.valorDaMultaSobreBaixa) > Math.abs(valorDaMultaDisponivelParaExtorno)){
			AlertModule.setError('Valor da Multa Excede o Total Dispoivel para Estorno')
			return
		}

		if(Math.abs(this.baixaDePagamento.valorJurosSobreBaixa) > Math.abs(valorDeJurosDisponivelParaExtorno)){
			AlertModule.setError('Valor do Juros Excede o Total Dispoivel para Estorno')
			return
		}

		if(Math.abs(this.baixaDePagamento.valorJurosSobreBaixa) + Math.abs(this.baixaDePagamento.valorDaMultaSobreBaixa) + Math.abs(this.baixaDePagamento.valorTaxa) + Math.abs(this.baixaDePagamento.valorDesconto) + Math.abs(this.baixaDePagamento.valorPagamento) === 0){
			AlertModule.setError('Necessario adicionar um valor para prosseguir')
			return
		}

		if(this.baixaDePagamento.formaDePagamento){
			this.formaDePagamento = this.baixaDePagamento.formaDePagamento
		}

		if (!this.formaDePagamento ) {
			return AlertModule.setError('Forma de pagamento é obrigatória!')
		}
		if (!this.baixaDePagamento.turnoDeVendaId && !this.contasAPagar) {
			return AlertModule.setError('Necessário Ponto De Venda')
		}
		
		try {
			this.salvando = true

			this.baixaDePagamento.formaDePagamento = this.formaDePagamento
			this.baixaDePagamento.dataHoraPagamento = `${this.data}T${this.horas}`
			this.baixaDePagamento = {
				...this.baixaDePagamento,
				tipoDeTransacao: TipoDeTransacaoDaBaixaDePagamento.ESTORNO,
				estornado: false,
				titulo: this.titulo,
				valorDaMultaSobreBaixa: this.baixaDePagamento.valorDaMultaSobreBaixa,
				valorJurosSobreBaixa: this.baixaDePagamento.valorJurosSobreBaixa,
				valorPagamento: this.baixaDePagamento.valorPagamento,
			}

			await this.createBaixaDePagamentoUseCase.create(this.baixaDePagamento)
			this.$emit('atualizar', this.baixaDePagamento)
			this.limparDados()

		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.salvando = false
			this.mostra = false
			this.limparDados()
		}
	}

	limparDados() {
		this.baixaDePagamento = {
			titulo: null,
			transactionId: '',
			valorPagamento: 0,
			valorTaxa: 0,
			dataHoraPagamento: '',
			isTaxa: false,
			isIntegracao: false,
			formaDePagamento: null,
			valorDesconto: 0,
			turnoDeVendaId: null,
			tipoDeTransacao: null,
			estornado: null,
			valorJurosSobreBaixa: 0,
			valorDaMultaSobreBaixa: 0,
			valorTotalTitulo: 0,
		}
		this.time = null
		this.dataPagamento = null
		this.data = ''
		this.horas = ''
		this.formaDePagamento = ''
		this.valorFaltante = 0
		this.valorFaltanteAtualizado = 0
		this.mostra = false
	}

	cancelar() {
		this.limparDados()
	}

	gerarDataHora(data?: string | null, hora?: string | null): string {
		const dateTimeString = `${data}T${hora}:00`;
		const localDateTime = moment(dateTimeString, 'YYYY-MM-DDTHH:mm:ss');
		const utcDateTime = localDateTime.utcOffset(0, true);
		const utcDateTimeString = utcDateTime.toISOString();

		return utcDateTimeString;
	}

	@Watch('mostra')
	onChangeMostra(mostra: boolean) {
		if (!mostra) return
		window.requestAnimationFrame(() => {
			this.form.resetValidation()
		})
	}

	@Watch('baixaDePagamento', { deep: true })
	corrigirValoresNegativos() {
		if (this.baixaDePagamento.valorPagamento > 0) {
			this.baixaDePagamento.valorPagamento *= -1
		}

		if (this.baixaDePagamento.valorTaxa > 0) {
			this.baixaDePagamento.valorTaxa *= -1
		}

		if (this.baixaDePagamento.valorDesconto > 0) {
			this.baixaDePagamento.valorDesconto *= -1
		}

		if (this.baixaDePagamento.valorJurosSobreBaixa > 0) {
			this.baixaDePagamento.valorJurosSobreBaixa *= -1
		}

		if(this.baixaDePagamento.valorDaMultaSobreBaixa > 0){
			this.baixaDePagamento.valorDaMultaSobreBaixa *= -1
		}
	}

	validarDataDePagamento(data) {
		if (!data) return true
		if (!this.titulo) return true

		const dataFormatada = moment(data, 'DD/MM/YYYY').format('YYYY-MM-DD')
		const dataDeCompetencia = this.titulo.dataDeCompetencia
		
		return dataFormatada < dataDeCompetencia ? 'A data do pagamento não pode ser anterior à data de competência' : true
	}
}
